import { Record } from 'immutable'

export interface ISocialConnection {
  readonly type: string
  readonly username: string
}

const SocialConnectionRecord = Record({
  type: '',
  username: '',
})

export class SocialConnection extends SocialConnectionRecord
  implements ISocialConnection {
  public static fromJS(initialState?: Partial<ISocialConnection>) {
    return new SocialConnection(initialState)
  }

  public readonly type: string
  public readonly username: string

  constructor(initialState?: Partial<SocialConnection>) {
    initialState ? super(initialState) : super()
  }
}
